import * as angular from "angular";
import template from "./alternative-confirmation.html";

export interface AlternativeConfirmationController {
	resolve: {
		label: string;
	};

	close(args: { $value: boolean }): void;

	dismiss(args: { $value: string }): void;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class AlternativeConfirmationController implements angular.IController {
	public confirm(): void {
		this.close({ $value: true });
	}

	public cancel(): void {
		this.dismiss({ $value: "cancel" });
	}
}

export default angular.module("vesl.extensions.json-schema.alternative-confirmation", [])
	.component("jsonSchemaAlternativeConfirmation", {
		template,
		controller: AlternativeConfirmationController,
		bindings: {
			resolve: "<",
			close: "&",
			dismiss: "&"
		}
	})
	.name;
